import { apiHelper } from "@/utils";
import { API } from "@/constants";

const API_URL = `${API.BASE_URL_API}/v1`;

export const articleService = {
  getAll,
  store,
  show,
  update,
  softDelete,
  updateStatus,
  updateActiveStatus,
};

export function getAll(filter = {}) {
  const params = {
    page: filter.pageNumber,
    size: filter.pageSize,
    article_category: filter.categoryUUID || undefined,
    status: filter.status === "" ? undefined : filter.status,
    audience_type: filter.audienceType === "" ? undefined : filter.audienceType,
    is_active: filter.isActive === "" ? undefined : filter.isActive,
    sortBy: filter.sortBy,
    orderBy: filter.orderBy,
  };

  const searchWords = (filter.searchArray || []).filter(
    (word) => word != null && word !== "",
  );
  if (searchWords.length) params.search_words = searchWords;

  return apiHelper(API_URL).get("/articles", { params });
}

function toFormData(data, method = null) {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("author_name", data.authorName || "");
  formData.append("description", data.description);
  formData.append("article_category_uuid", data.articleCategoryUUID);
  formData.append("article_type_uuid", data.articleTypeUUID);
  formData.append("visible_to_company_uuid", data.visibleToCompanyUUID || "");
  formData.append("status", data.status);
  formData.append("audience_type", data.audienceType);
  if (method) formData.append("_method", method);
  if (data.coverImage instanceof File)
    formData.append("cover_img", data.coverImage);
  return formData;
}

export function store(data) {
  return apiHelper(API_URL).post("/articles", toFormData(data));
}

export function show(uuid) {
  return apiHelper(API_URL).get(`/articles/${uuid}`);
}

export function update(data) {
  return apiHelper(API_URL).post(
    `/articles/${data.uuid}`,
    toFormData(data, "PUT"),
  );
}

export function softDelete(uuid) {
  return apiHelper(API_URL).patch(`/articles/delete/${uuid}`);
}

export function updateStatus(uuid, status) {
  return apiHelper(API_URL).patch(`/articles/article-status/${uuid}`, {
    status,
  });
}

export function updateActiveStatus(uuid, isActive) {
  return apiHelper(API_URL).patch(`/articles/${encodeURIComponent(uuid)}`, {
    is_active: [true, 1, "1"].includes(isActive) ? 1 : 0,
  });
}
